import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Pricing from './components/Pricing';
import Description from './components/Description';
import Gig from './components/Gig';
import Contact from './components/Contact';
import './App.css';
import './components/styles/global.css';
import ClientReviews from './components/ClientReviews';
import ReviewVideos from './components/ReviewVideos';
import Navbar from './components/Navbar'

function App() {
  const location = useLocation(); // Get the current location

  // Check if the current route is '/contact'
  const isContactPage = location.pathname === '/contact';

  return (
    <div className="app">
      <Sidebar />
      <Navbar/>
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Description />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/gig" element={<Gig />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/client" element={<ClientReviews />} />
          <Route path="/videos" element={<ReviewVideos />} />
        </Routes>
      </div>
      {/* Conditionally render the Hire Me button */}
      {!isContactPage && (
        <Link to="/contact" className="global-button">
          Hire Me 
        </Link>
      )}
    </div>
  );
}

// Wrap your App component in Router
export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}